export default "__VITE_ASSET__BsMXciEw__"